// Глобальные настройки ApexCharts. По умолчанию графики рисуются шрифтом Helvetica —
// приводим их к шрифту сайта (font-main / Geologica, подключён в public/index.html).
// ApexCharts читает window.Apex при создании каждого графика, поэтому одного этого
// импорта достаточно для всех диаграмм проекта.
window.Apex = {
	...(window.Apex || {}),
	chart: {
		...((window.Apex && window.Apex.chart) || {}),
		fontFamily: 'Geologica, sans-serif',
	},
}
